@if (breakpoints$ | async; as breakpoints) {
<!----------------- Desktop view -------------------------->
@if (breakpoints.isLargeScreen) {
<nav class="nav-desktop" aria-labelledby="logo">
  <img [src]="logoUrl" alt="logo" class="navbar-logo" />
  @if ((flow$ | async) === 'SERVICE_ORDER' && !isOnGeneralPage) { @if
  (activeStep$ | async; as activeStep) {
  <app-progress-bar
    class="center"
    [steps]="servicesProgressEntities"
    [activeStep]="activeStep"
  >
  </app-progress-bar>
  } } @if (enabledTranslations || (flow$ | async) === 'SERVICE_VACATION_HOME') {
  <app-translation-picker></app-translation-picker>
  }
</nav>
}
<!----------------- Mobile view -------------------------->
@if (!breakpoints.isLargeScreen) {
<div>
  <nav class="nav-mobile" aria-labelledby="logo">
    <div class="first-row">
      <img [src]="logoUrl" alt="logo" class="navbar-logo" />
      @if ( enabledTranslations || (flow$ | async) === 'SERVICE_VACATION_HOME' )
      {
      <app-translation-picker></app-translation-picker>
      }
    </div>
    @if ((flow$ | async) === 'SERVICE_ORDER' && !isOnGeneralPage) { @if
    (activeStep$ | async; as activeStep) {
    <app-progress-bar
      [steps]="servicesProgressEntities"
      [activeStep]="activeStep"
    ></app-progress-bar>
    } }
  </nav>
</div>
} }
